module.exports = __webpack_public_path__ + "img/cartaz-mobile.0616b49d.jpg";